// @ts-nocheck
import React from 'react';

const Checkbox = ({ id, placeholder, label, required, onInputChange }) => {
  const checkboxId = `checkbox-${id}`;
  const handleInputChange = (event) => {
    onInputChange(label, event.target.checked);
  };

  return (
    <div className="mb-6 flex flex-col">
      <label htmlFor={checkboxId} className="flex cursor-pointer items-start gap-3 rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-800 transition hover:border-emerald-300 hover:bg-emerald-50/50">
        <input
          id={checkboxId}
          type="checkbox"
          className="mt-0.5 h-5 w-5 rounded border-slate-300 text-emerald-700 focus:ring-emerald-500"
          onChange={handleInputChange}
          required={required}
        />
        <span>
          <strong className="block font-semibold">{label ? <span data-i18n-ignore="true">{label}</span> : 'Confirmação'} {required && <span className="text-red-500">*</span>}</strong>
          {placeholder && <small data-i18n-ignore="true" className="mt-1 block text-slate-500">{placeholder}</small>}
        </span>
      </label>
    </div>
  );
};

export default Checkbox;
